
import { Vue, Component, Prop } from 'vue-property-decorator';

export interface PaymentMethodType {
  text: string,
  value: string,
}

@Component
export default class PaymentMethodSelect extends Vue {
  @Prop({ required: true }) value!: PaymentMethodType;

  private items: PaymentMethodType[] = [
    {
      text: 'Account',
      value: 'Account',
    },
    {
      text: 'Credit card',
      value: 'CreditCard',
    },
  ]
}
